import { Component, inject, effect, Input } from '@angular/core';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';
import { PartnerService } from 'src/app/partners/service/partner.service';

@Component({
  selector: 'taly-partners',
  templateUrl: './taly-partners.component.html',
  styleUrls: ['./taly-partners.component.scss']
})
export class TalyPartnersComponent {
  responsiveOptions: any[] | undefined;
  merchantList: any[] = []
  transferSignal = inject(SharedSignalsService);
  @Input() textDirection: any;
  
  constructor(private PartnerService: PartnerService) {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    })
  }

  ngOnInit(): void {
    this.responsiveOptions = [
      {
        breakpoint: '1400px',
        numVisible: 4,
        numScroll: 4
      },
      {
        breakpoint: '1220px',
        numVisible: 4,
        numScroll: 4
      },
      {
        breakpoint: '1100px',
        numVisible: 3,
        numScroll: 3
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
      }
    ];
    this.getMerchant()
  }

  getMerchant() {
    let param = `page=0&size=8`;
    this.PartnerService.getShopsList(param).subscribe(resp => {
      this.merchantList = resp?.records;
    }, err => {
      this.transferSignal.showMessage('error', err?.message || err)
    })
  }
}
